import React from 'react';

import PlaceholderTab from '~/components/Offers/Detail/OfferBuilder/shared/PlaceholderTab';

import { PRICING_SUMMARY_FIELDS } from './fields';

export default function PricingSummaryTab() {
  return <PlaceholderTab configuredFieldCount={PRICING_SUMMARY_FIELDS.length} title="Pricing Summary" />;
}
